<template>
  <div class="w-100">
      <div class="p-list-representation-wrapper align-items-start">
          <Loader class="w-100" :loading="loading">
            <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
              <div class="w-100" >
                <appHeader></appHeader>
              </div>

              <div class=" row p-list-representation-data w-100">
                <contentList
                @updateStatusModalTransactionRecord="updateStatusModalTransactionRecord"
                @selectedCity="selectedCity"
                @selectedProvince="selectedProvince"
                @searchTableRepresentation="searchTableRepresentation"
                @submitModalDataTransaction="submitModalDataTransaction"

                :page="page"
                :update-city-selected="updateCitySelected"
                :city-selected     = "citySelected"
                :province-selected = "provinceSelected"
                :citys="citys"
                :province-items="provinceItems"
                :excel-data="excelData"
                :status-show-transaction-record="statusShowTransactionRecord"
                :click-btn-transaction-value-representation="clickBtnTransactionValueRepresentation"
                :loading-transaction-form="loadingTransactionForm"
                ></contentList>
              </div>

            </div>

          <tableContent
           :table-data="tableData"
           :page="page"
           @paganationChangePage="paganationChangePage"
            @modalShowTransactionRecord="modalShowTransactionRecord"
            @editRepresentation="editRepresentation"
            ></tableContent>

        </Loader>
      </div>
  </div>
</template>

<script>
import contentList from '../components/listRepresentation/contentList';
import appHeader from '../components/includes/AppHeader';
import tableContent from '../components/listRepresentation/tableContent';
import settings from '../modules/settings';



export default {
  name: "listRepresentation",
  components: {
    contentList,
    appHeader,
    tableContent,
  },

  props: {

  },

  data() {
    return {
      loading                               : true,
      citys                                 : [
      ],
      provinceItems                         : [
      ],
      excelData                             : [
            {
              family         : 'محمد صالح معافی',
              city           : 'قم',
              representation : 'استان',
              phone          : '09198814783',
            },
      ],
      statusShowTransactionRecord           : false,
      valueRepresentationAndProvinceAndCity : [],
      citySelected                          : {
        id    : -1,
        title : 'انتخاب کنید',
      },
      provinceSelected                      : {
        id                 : -1,
        title              : 'انتخاب کنید',
      },
      updateCitySelected                    : 0,
      tableData                             : [],
      page                                  : 1,
      searchAndGetDataTableAndchangePage    : {
        national_code : '',
        name          : '',
        city_id       : '',
        province_id   : '',
        description   : '',
        national_code : '',
        per_page      : 10,
        page          : 1,
      },
      clickBtnTransactionValueRepresentation              : {},
      loadingTransactionForm                              : false,
      checkRunFirstGetDefaultProvinceAndCity              : 'initialLoaded',
      checkPermissionMultiUpdateTableData                 : true,


    }
  },

  watch: {


  },

  created() {
    // const token = `eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiNmMzYzcyNGY3MTU5Nzg2YzgzNjY1MTUwZWY4Nzg4OGJkNjY1ZTFlYzgyNzViMjlhMjU2YTc1MjkyYWQwYTlmYTI1MTY1NDc0ZjU3NTZkMzUiLCJpYXQiOjE2MDc4NTY2MjUsIm5iZiI6MTYwNzg1NjYyNSwiZXhwIjoxNjM5MzkyNjI1LCJzdWIiOiIxIiwic2NvcGVzIjpbImFwaV9hZG1pbiJdfQ.w-s1VO8dH42QJ-tJCl4ayGqPLbtg-p2mT5SVKPj5DPZpHwlXn9CRUOey9lhkAwbMsgbt5d1EQX68nmtM-TzwmuYsPgrWHjOjVaP1G_vimhEJSa47IdDyf4eA5ZyxqJ42sftVGfQWiCWWne3aVkcmZVjzm_KdVneHtN_nbxaIsLyoohkXJnmDmVvz6AzBl8SlHHn3xfKWWpRbvl1E3-dbgmm6bE1CmdgVhZZ04hnjo3yRR9pEFlOycDXARPJ37OxDwi01dQUTUJ2C1lb3CoMvG9-4btAtC6hhmGRUTUzr7y0hOwicVT8KiniY9Y1AZT_A8QkBoCk_WPcfuuKh5-tddVewg-ut8zmJxwDHxziiUShaSt9YncQ_6AQdoM_Kn71igZXpnEI__PSZ_mCWBTOLp4uQxMDN3c0NYxZPSWimUAeMuD4r25iYygnabR20V_80lJxchR16KzxQjKjiR4VZzlLBEpb83-rO8to7oTtcFDXpWsGYN3zBEHgrOwV3tbEfNntc3fFUeqmRcuSr0Qmk4om3NGIN-NTJtp9GWrgeHqS8_ir-tXOqWPcUg-IFIOzmnzNNkYt-xyrI84KC594Py6S9I6e8owPIwFIAIdSGHdX7ufKFLKty6ScfThqG3u7LJIL4HaXTAgpFkh-eKDde6afpXH5sm0UopOit7kndhPY`;
    //
    // settings.set('authorization',`Bearer ${token}`);
  },

  mounted() {
    this.getRepresentationAndProvinceAndCity();
  },


  methods: {
    searchTableRepresentation(NameAndCodeNatinal){
      if (this.citySelected.id == -1) {
        this.searchAndGetDataTableAndchangePage.city_id = '';
      }

      for (let content in NameAndCodeNatinal) {
        this.searchAndGetDataTableAndchangePage[content] = NameAndCodeNatinal[content];
      }

      this.loading                                 = true;
      this.page                                    = 1;
      this.searchAndGetDataTableAndchangePage.page = this.page;
      this.checkRunFirstGetDefaultProvinceAndCity  = 'preventGetProvinceAndCity';

      this.checkPermissionMultiUpdateTableData     = false;

      // search data //
      this.getRepresentationAndProvinceAndCity();
    },

    paganationChangePage(data){
      if (!this.checkPermissionMultiUpdateTableData) {
        // در صورتی که کاربر در صفحه دو تیبل باشد  و عدد صفحه تیبل تغییر کند //
        // دو در خواست اجرا می شود برای جلوگیری از دو در خواست همزمان //
        // کد زیر نوشته شد //
        if (data != 1) {
          this.checkPermissionMultiUpdateTableData = true;
        }
      }


      if (this.checkPermissionMultiUpdateTableData) {
          if (this.citySelected.id == -1) {
            this.searchAndGetDataTableAndchangePage.city_id = '';
          }

          this.page                                    = data;
          this.loading                                 = true;
          this.searchAndGetDataTableAndchangePage.page = this.page;
          this.checkRunFirstGetDefaultProvinceAndCity  = 'preventGetProvinceAndCity';

          this.getRepresentationAndProvinceAndCity();
      }
      else {
        // اجازه اجرا شدن لاجیک کال بک پجینیشن //
        this.checkPermissionMultiUpdateTableData = true;
      }

    },

    modalShowTransactionRecord(data){
      this.statusShowTransactionRecord            = true;
      this.clickBtnTransactionValueRepresentation = data;
    },

    editRepresentation(data){
      const id = data.id;
      this.$router.push({name:'editRepresentation' , params:{id:id} , query:data } )
    },

    updateStatusModalTransactionRecord(status){
      if (!status) {
        this.statusShowTransactionRecord = false;
      }
    },

    getRepresentationAndProvinceAndCity(){
      this.$store
      .dispatch('listRepresentation/getRepresentationAndProvinceAndCity', {
        data : {
          ...this.searchAndGetDataTableAndchangePage,
        }
      })
      .then((res)=>{
        this.loading                               = false;
        this.valueRepresentationAndProvinceAndCity = res;

        if (this.checkRunFirstGetDefaultProvinceAndCity == 'initialLoaded') {
          this.getDefaultProvinceAndCity(res.getProvinceAndCity);
        }

        this.findProvinceAndCityTable(res.listRepresentation.data);
        this.tableData    = res.listRepresentation.data;
      })
    },

    getDefaultProvinceAndCity(dataProvinceAndCity){
      let getProvince = [];
      let getCity     = [];

      dataProvinceAndCity.data.map((t)=>{
          t.title     = t.name;
          getProvince = [...getProvince,t];
          t.city.map((contentCity)=>{
            contentCity.title     = contentCity.name;
            getCity               = [...getCity,contentCity];
          })
      })

      this.citys            = getCity;
      this.provinceItems    = getProvince;
    },

    selectedCity(data){
      if (data.id != -1 &&  data.id != -2) {
        this.citySelected   = data
      }

      this.searchAndGetDataTableAndchangePage.city_id = data.id;
    },

    selectedProvince(data){
      if (data.id != -1 &&  data.id != -2) {
        this.citys            = data.city;
        this.citySelected     = {title:'انتخاب کنید',id:-1};
        this.provinceSelected = data;
        this.updateCitySelected++;
      }

      this.searchAndGetDataTableAndchangePage.province_id =  data.id;
    },

    convertDateStampInToJalali(res){
      const data              = res.updated_at;
      const dateTimeCredit    = this.$moment.unix(data.last_checkout).format("jYYYY/jMM/jDD HH:mm:ss").split(' ');

      data.addCamaCredit      = addCama(data.credit)
    },

    findProvinceAndCityTable(listRepresentation){
          listRepresentation.map((contentRepresentation)=>{
              this.provinceItems.map((t)=>{
                if (t.id == contentRepresentation.province_id) {
                    contentRepresentation.findProvinceOfAllProvinces = t;

                    t.city.map((contentCity)=>{
                        if (contentCity.id == contentRepresentation.city_id) {
                            contentRepresentation.findCityOfAllCitys = contentCity;
                        }
                    })

                }
              })
        })
    },

    submitModalDataTransaction(data){
      this.loadingTransactionForm                      = true;
      const resultClickTransactionValueRepresentation  = this.clickBtnTransactionValueRepresentation;
      data.agent_id                                    = resultClickTransactionValueRepresentation.id;

      for (let key in resultClickTransactionValueRepresentation) {
        data[key] = resultClickTransactionValueRepresentation[key]
      }

      this.$store
      .dispatch('listRepresentation/submitTransactionForm', {
        data : {
          ...data,
        }
      })
      .then((res)=>{
        this.loadingTransactionForm       = false;
        this.statusShowTransactionRecord  = false;
      })
    }


  }


}
</script>
